{
  "import": "Import",
  "export": "Export",
  "dashboards": {
    "label": "Dashboards",
    "view": "Dashboards view",
    "edit": "Manage dashboards",
    "publish": "Dashboards publish",
    "export": "Export",
    "import": "Import"
  },
  "cli": {
    "label": "Console",
    "connection": "Connection",
    "logs": "Terminal logs"
  },
  "third_party_service": {
    "label": "Third-party services",
    "os_dashboards": "Opensearch",
    "flower": "Flower",
    "alertmanager": "AlertManager",
    "rabbitmq": "RabbitMQ",
    "metrics_agent": "Metrics-agent",
    "metrics_storage": "Metrics-storage",
    "metrics_ruler": "Metrics-ruler"
  },
  "srm": {
    "label": "SRM",
    "view": "View SRM",
    "edit": "Edit SRM",
    "export": "Export SRM",
    "import": "Import SRM",
    "tql": {
      "edit": "Edit TQL"
    },
    "modelling": {
      "label": "SRM Modelling",
      "view": "View SRM model",
      "edit": "Edit SRM model",
      "mon": {
        "view": "View SRM monitoring model",
        "edit": "Edit SRM monitoring model"
      },
      "enrichmentPlans": {
        "label": "Enrichment plans",
        "view": "View plans",
        "edit": "Create, edit and delete plans"
      },
      "enrichmentProcesses": {
        "label": "Enrichment processes",
        "view": "View processes"
      },
      "citSections": {
        "title": "CIT sections",
        "cit": "CIT",
        "attributes": "Attributes",
        "links": "Available links",
        "healthIndicators": "Health indicators",
        "createCI": "CI list",
        "naming": "Naming",
        "identification": "Identification",
        "deletePolicy": "Retention"
      }
    },
    "enrichment": {
      "label": "Enrichment plans",
      "export": "Export plans",
      "import": "Import plans"
    },
    "ci": {
      "label": "CI",
      "export": "Export CI",
      "import": "Import CI"
    },
    "cit": {
      "label": "CIT",
      "export": "Export CIT",
      "import": "Import CIT"
    },
    "external": {
      "routes": {
        "get": "SRM API"
      }
    }
  },
  "monitoring": {
    "label": "Monitoring",
    "vmagents": {
      "label": "Metrics collection agents"
    },
    "vmalerts": {
      "label": "Rules processing agents"
    },
    "hi": {
      "label": "Health indicators",
      "edit": "Edit health indicators",
      "export": "Export health indicators",
      "import": "Import health indicators"
    },
    "templates": {
      "label": "Monitoring templates",
      "edit": "Edit monitoring templates",
      "export": "Export templates",
      "import": "Import templates"
    },
    "prometheus": {
      "label": "Prometheus",
      "exporters": {
        "label": "Exporters",
        "edit": "Edit Prometheus exporters",
        "export": "Export exporters",
        "import": "Import exporters"
      },
      "jobs": {
        "label": "Jobs",
        "edit": "Edit Prometheus jobs",
        "export": "Export jsobs",
        "import": "Import jobs"
      },
      "edit": "Edit Prometheus"
    }
  },
  "users": {
    "label": "Users",
    "edit": "Edit users",
    "change_password": {
      "edit": "Change local users password"
    },
    "status": {
      "edit": "Change user's lock status"
    },
    "attribute": {
      "edit": "Edit profile attributes"
    },
    "profile": {
      "view": "View users",
      "edit": "Create and edit users"
    },
    "ldap": {
      "edit": "Setup LDAP"
    },
    "oidc": {
      "edit": "Setup OIDC"
    },
    "delete": {
      "edit": "Delete users"
    },
    "api_token": {
      "edit": "Managing API tokens"
    },
    "activity": {
      "log": "Audit logs"
    },
    "session": {
      "kill": "Forced termination of a user session"
    }
  },
  "access": {
    "label": "Access control",
    "srm": {
      "edit": "SRM"
    },
    "monitoring": {
      "edit": "Health indicators"
    },
    "dashboards": {
      "edit": "Dashboards"
    },
    "func": {
      "edit": "System functions"
    },
    "tql": {
      "edit": "TQL"
    }
  },
  "notifications": {
    "label": "Notifications",
    "self": {
      "edit": "Personal notifications"
    },
    "external": {
      "edit": "External services"
    },
    "template": {
      "edit": "Notification templates"
    },
    "alertmanager": {
      "edit": "Alert Manager"
    }
  },
  "settings": {
    "edit": "Global settings"
  },
  "accessDialog": {
    "title": "Warning!",
    "accessChanged": "Your access has been changed!",
    "accept": "Accept"
  },
  "noAccessPage": {
    "no-access-rules": "You don't have permissions to use application",
    "change-user": "Change user"
  },
  "system": {
    "docker": {
      "label": "Components",
      "edit": "Edit",
      "view": "View",
      "run": "Run"
    },
    "content-pack": {
      "label": "Content Pack",
      "create": "Create",
      "import": "Import"
    },
    "plugins": {
      "edit": "Edit plugins"
    },
    "debug": {
      "edit": "System debug"
    },
    "label": "System settings",
    "settings": {
      "label": "Global settings",
      "auth": {
        "label": "Authorization service",
        "view": "View",
        "edit": "Edit"
      },
      "srm": {
        "label": "SRM service",
        "view": "View",
        "edit": "Edit"
      },
      "monitoring": {
        "label": "Monitoring service",
        "view": "View",
        "edit": "Edit"
      },
      "notification": {
        "label": "Notification service",
        "view": "View",
        "edit": "Edit"
      },
      "docker_tool": {
        "label": "Docker Tool",
        "view": "View",
        "edit": "Edit"
      },
      "task_tool": {
        "label": "Task Tool",
        "view": "View",
        "edit": "Edit"
      }
    }
  },
  "license": {
    "edit": "Лицензия"
  }
}
